import React from 'react'
import { RotatingTriangles } from 'react-loader-spinner'

export default function Loader() {
  return (
    <>
      <RotatingTriangles
        height="80"
        width="80"
        radius="9"
        color="red"
        ariaLabel="loading"
        wrapperStyle={{ margin: "0 auto", display: "flex", alignItems:"center", justifyContent: "center" }}
        wrapperClass=""
      />
    </>
  )
}
